<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import firebase from "firebase";
import { mapGetters, mapActions } from "vuex";
import { unsplash } from "./util/vendors/unsplash";

export default {
  data() {
    return {};
  },
  mounted() {
    this.loadImagesFromUnsplash();
    this.loadAllData();
  },
  computed: {},
  methods: {
    ...mapActions(["setImages","loadAllData"]),
    loadImagesFromUnsplash() {
      const all = Promise.all([
        unsplash.search.photos("face", 1, 30).then(resp => resp.json()),
        unsplash.search.photos("macbook desk", 1, 30).then(resp => resp.json()),
        unsplash.search.photos("macbook desk", 2, 30).then(resp => resp.json()),
        unsplash.search.photos("office", 1, 30).then(resp => resp.json()),
        unsplash.search.photos("abstract", 1, 30).then(resp => resp.json()),
        unsplash.search.photos("cofee", 1, 30).then(resp => resp.json())
      ]);
      all.then(json => {
        const images = json
          .flatMap(item => item.results)
          .map(({ urls }) => ({ thumb: urls.thumb, regular: urls.regular }));
        this.setImages({ images });
      });
    }
  }
};
/* eslint-enable no-unused-vars */
</script>

<style>
@import url("./app.css");
@import "./../node_modules/codemirror/lib/codemirror.css";
@import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900&display=swap");
@import url("https://fonts.googleapis.com/css?family=Bellota+Text:400,700|Bellota:400,700|Lato:400,700|Open+Sans:400,700|PT+Sans:400,700|Playfair+Display:400,700|Roboto:400,700|Sen:400,700&display=swap");
/* 


*/

.font-bellota {
  font-family: "Bellota", cursive;
}

.font-lato {
  font-family: "Lato", sans-serif;
}

.font-sen {
  font-family: "Sen", sans-serif;
}

.font-roboto {
  font-family: "Roboto", sans-serif;
}

.font-open-sans {
  font-family: "Open Sans", sans-serif;
}

.font-pt-sans {
  font-family: "PT Sans", sans-serif;
}

.font-playfair {
  font-family: "Playfair Display", serif;
}

html[data-theme="dark"] {
  --bg: #1a202c;
  --bg-panel: #414857;
  --bg-panel-sec: #4a5364;
  --bg-controls: #35a3a1;
  --bg-tabs: #414857;
  --bg-tabs-selected: #777d8b;
  --color-heading: #73e2c4;
  --color-text: #cad4df;
  --color-text-muted: rgb(131, 133, 139);
}

html[data-theme="light"] {
  --bg: #60636a;
  --bg-panel: #a8acb4;
  --bg-controls: rgb(36, 145, 138);
  --color-heading: rgb(54, 134, 129);
  --color-text: rgb(79, 79, 79);
  --color-text-muted: rgb(79, 79, 79);
}

body {
  font-family: "Roboto";
}

.bg {
  background: var(--bg);
}
.bg-panel {
  background: var(--bg-panel);
}
.bg-panel-sec {
  background: var(--bg-panel-sec);
}
.bg-controls {
  background: var(--bg-controls);
}
.bg-tabs {
  background: var(--bg-tabs);
}
.bg-tabs-selected {
  background: var(--bg-tabs-selected);
}

.color-heading {
  color: var(--color-heading);
}

.color-text {
  color: var(--color-text);
}

.color-text-muted {
  color: var(--color-text-muted);
}

.header {
  grid-area: header;
}
.main {
  grid-area: main;
}
.toolsBar {
  grid-area: toolsBar;
}
.iconsBar {
  grid-area: iconsBar;
}
.manager {
  grid-area: manager;
}
.footer {
  grid-area: footer;
}

.grid {
  display: grid;

  grid-template-rows: 2.2rem auto 2rem;
  grid-template-columns: 4rem 8rem 10fr 20rem;
  grid-template-areas:
    "header header header header"
    "iconsBar toolsBar main manager"
    "footer footer footer footer";
  height: 100vh;
}

.grid > div {
  /* border: 1px dashed orange; */
}

.CodeMirror {
  border: 1px solid #eee;
  height: 85vh;
}
.cursor-resize {
  cursor: ns-resize;
}

.outline {
  outline: 1px dashed rgb(212, 208, 240);
}

.outline-select {
  outline: 1px dashed rgb(94, 98, 222);
}

.min {
  min-height: 32px;
  min-width: 32px;
}

.tab {
  font-size: 10px;
  padding: 4px 16px;
  background: #ccc;
  color: rgb(106, 106, 106);
  border-radius: 4px 4px 0px 0px;
}

.tab.active {
  color: rgb(254, 254, 254);
  font: bold;
  background: rgb(95, 87, 184);
}

.btn {
  background: rgb(74, 185, 165);
  outline: none;
  border: none;
  padding: 4px 8px;
  font-size: 12px;
  border:1px solid rgb(85, 86, 143,0.6);

}

.btn:focus {
  border:1px solid rgb(85, 86, 143,0.6);
  border: none;
  outline: none;
}

.btn:active {
  border:1px solid rgb(85, 86, 143,0.6);
  background: rgb(46, 109, 94);
}
.btn:hover {
  background: rgb(115, 226, 196);
}

.form-control {
  outline: none;
}

.form-control {
  border: none;
  outline: none;
  background: var(--bg-tabs);
  color: var(--color-text);
  padding: 4px 8px;
  font-size: 12px;
}


.form-control-dark {
  border: none;
  outline: none;
  background: var(--bg);
  color: var(--color-text);
  padding: 4px 8px;
  font-size: 12px;
}

.tool-button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border: 1px dashed var(--color-text-muted);
  color: var(--color-text-muted);
  border-radius: 5px;
  margin-top: 10px;
  cursor: pointer;
}

.tool-button:hover {
  color: var(--color-text);
  border: 1px dashed var(--color-text);
}

.tool-button:active {
  color: var(--color-text-muted);
  border: 1px dashed var(--color-text-muted);
}

.tool-button > p {
  font-size: 12px;
}

/* width */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(136, 136, 136, 0.6);
  width: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(177, 177, 177, 0.6);
}


.grid-default{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-gap: 4px;
}
</style>
